import createIcon from '../../createIcon';

/**
 * @component @name AirplanemodeInactive
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuODA0OCA3LjM2NTMxVjMuMTk1MzFDMTAuODA0OCAyLjM2NTMxIDExLjQ3NDggMS42OTUzMSAxMi4zMDQ4IDEuNjk1MzFDMTMuMTM0OCAxLjY5NTMxIDEzLjgwNDggMi4zNjUzMSAxMy44MDQ4IDMuMTk1MzFWOC42OTUzMUwyMi4zMDQ4IDEzLjY5NTNWMTUuNjk1M0wxNy44MTQ4IDE0LjM3NTNMMTAuODA0OCA3LjM2NTMxWk0yMC4wODQ4IDIyLjMwNTNMMjEuNDk0OCAyMC44OTUzTDMuMTE0ODIgMi41MDUzMUwxLjY5NDgyIDMuOTE1MzFMOC4wNzQ4MiAxMC4yOTUzTDIuMzA0ODIgMTMuNjk1M1YxNS42OTUzTDEwLjgwNDggMTMuMTk1M1YxOC42OTUzTDguMzA0ODIgMjAuMTk1M1YyMS42OTUzTDEyLjMwNDggMjAuNjk1M0wxNi4zMDQ4IDIxLjY5NTNWMjAuMTk1M0wxMy44MDQ4IDE4LjY5NTNWMTYuMDI1M0wyMC4wODQ4IDIyLjMwNTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AirplanemodeInactive = createIcon('AirplanemodeInactive', [
  [
    'path',
    {
      d: 'M10.8048 7.36531V3.19531C10.8048 2.36531 11.4748 1.69531 12.3048 1.69531C13.1348 1.69531 13.8048 2.36531 13.8048 3.19531V8.69531L22.3048 13.6953V15.6953L17.8148 14.3753L10.8048 7.36531ZM20.0848 22.3053L21.4948 20.8953L3.11482 2.50531L1.69482 3.91531L8.07482 10.2953L2.30482 13.6953V15.6953L10.8048 13.1953V18.6953L8.30482 20.1953V21.6953L12.3048 20.6953L16.3048 21.6953V20.1953L13.8048 18.6953V16.0253L20.0848 22.3053Z',
      key: '1vm9ns',
    },
  ],
]);

export default AirplanemodeInactive;
